<app-multi-select #multiSelect [inputModel]="filterTerm" (updated)="filterTermUpdated($event)"
                  [data]="sourcesProvider.data" [filterFunction]="filterSources" [inputBufferTime]="200"
                  [placeholder]="'Filter...'" [selectedItems]="selectedItems" (termChanged)="filterTermChanged($event);"
                  [itemTemplate]="rt" (deleted)="deleteSource($event)">
    <ng-template #rt let-item>
        <span class="notranslate" (click)="openWithSpecificItem(item)">
            <ng-container *ngIf="item.info.type === 'meter' else others">
                <app-meter-image [connectionType]="item.info.connectionType" [meterType]="item.info.meterType" [virtual]="item.info.source.meter.info.virtual"
                                 class="d-inline-block" style="filter: grayscale(100%);"></app-meter-image>
            </ng-container>
            <ng-template #others>
                <i class="me-2 bi" [ngClass]="appContext.getIconOfSourceType(item.info.type, item.info.connectionType, item.info.meterType)"></i>
            </ng-template>
            <span class="notranslate" data-bs-toggle="tooltip" [attr.data-bs-title]="item.info.filteredNameOverride || item.info.name">
                {{item.info.name}}
            </span>
        </span>
    </ng-template>
    <div #sourceListDropdownMenu class="dropdown-menu py-0" [ngClass]="positionClass" style="max-width: 100vw; min-width: 100%;">
        <ng-container *ngIf="dropdownOpen">
            <app-dashboard-sources-list #scrollableMenu [data]="sourcesProvider.filteredData" [filterTerm]="filterTerm" class="overflow-auto d-block position-relative" style="max-height: 400px;"
                                    [sourcesProvider]="sourcesProvider" (selectionChange)="selectionChanged()" recordCls="dropdown-item"></app-dashboard-sources-list>
        </ng-container>
    </div>
</app-multi-select>
